import Box from '@mui/material/Box'

import { NO_MOTION, beat } from '../theme/animations'

// The dot beside a user's Active / Inactive label in the table.
// Online beats softly; offline is a hollow ring that sits still.
export function StatusDot({ active, size = 6 }) {
  return (
    <Box
      component="span"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        flexShrink: 0,
        ...(active
          ? {
              bgcolor: 'custom.up',
              animation: `${beat} 1.9s ease-in-out infinite`,
              [NO_MOTION]: { animation: 'none' },
            }
          : {
              border: '1.5px solid',
              borderColor: 'custom.downText',
              bgcolor: 'transparent',
            }),
      }}
    />
  )
}

// The dot in the side rail, showing whether our own connection is alive.
// It beats only while the feed is live, so a still dot means a dead feed.
export function AgentPulse({ size = 5, live = true }) {
  return (
    <Box
      component="span"
      sx={{
        width: size,
        height: size,
        borderRadius: '50%',
        bgcolor: live ? 'custom.up' : 'custom.downText',
        animation: live ? `${beat} 2s ease-in-out infinite` : 'none',
        [NO_MOTION]: { animation: 'none' },
      }}
    />
  )
}
